import React from 'react'

import { Box, withCitrusTheme } from '@gousto-internal/citrus-react'
import { useSelector } from 'react-redux'

import { MenuRecipe, MenuRecipeImage } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { getBrowserType } from 'selectors/browser'
import { getFeaturedImage, getRangeImages } from 'utils/image'

import { DetailCarousel } from '../Carousel'
import { DetailImage } from '../DetailImage'

type RecipeImageProps = {
  foodBrand: MenuRecipe['food_brand']
  images: MenuRecipeImage[]
  title: string
}

const ImageContainer = withCitrusTheme(Box, (theme) => ({
  marginLeft: `-${theme.spacing(4)}px`,
  marginTop: `-${theme.spacing(4)}px`,
  width: `calc(100% + 2*${theme.spacing(4)}px)`,
  [`@media (min-width: ${theme.tokens.breakpoints[0]})`]: {
    marginLeft: `-${theme.spacing(6)}px`,
    marginTop: `-${theme.spacing(6)}px`,
    width: `calc(100% + 2*${theme.spacing(6)}px)`,
  },
}))

export const RecipeImage = ({ foodBrand, images, title }: RecipeImageProps) => {
  const browserType = useSelector(getBrowserType)

  const isFineDineIn = foodBrand?.slug === 'fine-dine-in'
  const view = isFineDineIn ? 'fineDineInDetail' : 'detail'

  const featuredImage = getFeaturedImage(images, 'detail', browserType)

  if (!isFineDineIn) {
    return <DetailImage media={featuredImage} title={title} view={view} />
  }

  const rangeImages = getRangeImages(images)

  return (
    <ImageContainer>
      <DetailCarousel images={rangeImages} fallbackImage={featuredImage} />
    </ImageContainer>
  )
}
